import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=3e37279d&scoped=true&"
import script from "./ScrollToTop.vue?vue&type=script&lang=js&"
export * from "./ScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&id=3e37279d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e37279d",
  null
  
)

export default component.exports